export const iconCategoryTranslations = {
  english: {
    ICON_LIST: {
      title: "Icon List",
      categories: "Categories",
    },
    ICON_CATEGORIES: {
      accessibility: "Accessibility",
      alert: "Alert",
      alphabet: "Alphabet",
      animals: "Animals",
      arrows: "Arrows",
      astronomy: "Astronomy",
      automotive: "Automotive",
      buildings: "Buildings",
      business: "Business",
      camping: "Camping",
      charity: "Charity",
      charts_diagrams: "Charts & Diagrams",
      childhood: "Childhood",
      clothing_fashion: "Clothing & Fashion",
      coding: "Coding",
      communication: "Communication",
      connectivity: "Connectivity",
      construction: "Construction",
      design: "Design",
      devices_hardware: "Devices & Hardware",
      disaster: "Disaster",
      editing: "Editing",
      education: "Education",
      emoji: "Emoji",
      energy: "Energy",
      files: "Files",
      film_video: "Film & Video",
      food_beverage: "Food & Beverage",
      fruits_vegetables: "Fruits & Vegetables",
      gaming: "Gaming",
      gender: "Gender",
      halloween: "Halloween",
      hands: "Hands",
      holidays: "Holidays",
      household: "Household",
      humanitarian: "Humanitarian",
      logistics: "Logistics",
      maps: "Maps",
      maritime: "Maritime",
      marketing: "Marketing",
      mathematics: "Mathematics",
      media_playback: "Media Playback",
      medical_health: "Medical & Health",
      money: "Money",
      moving: "Moving",
      music_audio: "Music & Audio",
      nature: "Nature",
      numbers: "Numbers",
      photos_images: "Photos & Images",
      political: "Political",
      punctuation_symbols: "Punctuation & Symbols",
      religion: "Religion",
      science: "Science",
      science_fiction: "Science Fiction",
      security: "Security",
      shapes: "Shapes",
      shopping: "Shopping",
      social: "Social",
      spinners: "Spinners",
      sports_fitness: "Sports & Fitness",
      text_formatting: "Text Formatting",
      time: "Time",
      toggle: "Toggle",
      transportation: "Transportation",
      travel_hotel: "Travel & Hotel",
      users_people: "Users & People",
      weather: "Weather",
      writing: "Writing",
    },
  },
  turkish: {
    ICON_LIST: {
      title: "İkon Listesi",
      categories: "Kategoriler",
    },
    ICON_CATEGORIES: {
      accessibility: "Erişilebilirlik",
      alert: "Uyarı",
      alphabet: "Alfabe",
      animals: "Hayvanlar",
      arrows: "Oklar",
      astronomy: "Astronomi",
      automotive: "Otomotiv",
      buildings: "Binalar",
      business: "İş Dünyası",
      camping: "Kamp",
      charity: "Hayır Kurumu",
      charts_diagrams: "Grafikler ve Diyagramlar",
      childhood: "Çocukluk",
      clothing_fashion: "Giyim ve Moda",
      coding: "Kodlama",
      communication: "İletişim",
      connectivity: "Bağlantı",
      construction: "İnşaat",
      design: "Tasarım",
      devices_hardware: "Cihazlar ve Donanım",
      disaster: "Afet",
      editing: "Düzenleme",
      education: "Eğitim",
      emoji: "Emoji",
      energy: "Enerji",
      files: "Dosyalar",
      film_video: "Film ve Video",
      food_beverage: "Yiyecek ve İçecek",
      fruits_vegetables: "Meyveler ve Sebzeler",
      gaming: "Oyun",
      gender: "Cinsiyet",
      halloween: "Cadılar Bayramı",
      hands: "Eller",
      holidays: "Tatiller",
      household: "Ev Yaşamı",
      humanitarian: "İnsani Yardım",
      logistics: "Lojistik",
      maps: "Haritalar",
      maritime: "Denizcilik",
      marketing: "Pazarlama",
      mathematics: "Matematik",
      media_playback: "Medya Oynatma",
      medical_health: "Sağlık ve Tıp",
      money: "Para",
      moving: "Taşınma",
      music_audio: "Müzik ve Ses",
      nature: "Doğa",
      numbers: "Sayılar",
      photos_images: "Fotoğraflar ve Görseller",
      political: "Politika",
      punctuation_symbols: "Noktalama ve Semboller",
      religion: "Din",
      science: "Bilim",
      science_fiction: "Bilim Kurgu",
      security: "Güvenlik",
      shapes: "Şekiller",
      shopping: "Alışveriş",
      social: "Sosyal",
      spinners: "Yükleme Göstergeleri",
      sports_fitness: "Spor ve Fitness",
      text_formatting: "Metin Biçimlendirme",
      time: "Zaman",
      toggle: "Anahtarlar",
      transportation: "Ulaşım",
      travel_hotel: "Seyahat ve Otel",
      users_people: "Kullanıcılar ve İnsanlar",
      weather: "Hava Durumu",
      writing: "Yazma",
    },
  },
  german: {
    ICON_LIST: {
      title: "Icon-Liste",
      categories: "Kategorien",
    },
    ICON_CATEGORIES: {
      accessibility: "Barrierefreiheit",
      alert: "Alarm",
      alphabet: "Alphabet",
      animals: "Tiere",
      arrows: "Pfeile",
      astronomy: "Astronomie",
      automotive: "Automobil",
      buildings: "Gebäude",
      business: "Geschäft",
      camping: "Camping",
      charity: "Wohltätigkeit",
      charts_diagrams: "Diagramme & Grafiken",
      childhood: "Kindheit",
      clothing_fashion: "Bekleidung & Mode",
      coding: "Programmierung",
      communication: "Kommunikation",
      connectivity: "Konnektivität",
      construction: "Bauwesen",
      design: "Design",
      devices_hardware: "Geräte & Hardware",
      disaster: "Katastrophe",
      editing: "Bearbeitung",
      education: "Bildung",
      emoji: "Emoji",
      energy: "Energie",
      files: "Dateien",
      film_video: "Film & Video",
      food_beverage: "Essen & Getränke",
      fruits_vegetables: "Obst & Gemüse",
      gaming: "Gaming",
      gender: "Geschlecht",
      halloween: "Halloween",
      hands: "Hände",
      holidays: "Feiertage",
      household: "Haushalt",
      humanitarian: "Humanitär",
      logistics: "Logistik",
      maps: "Karten",
      maritime: "Maritim",
      marketing: "Marketing",
      mathematics: "Mathematik",
      media_playback: "Medienwiedergabe",
      medical_health: "Medizin & Gesundheit",
      money: "Geld",
      moving: "Umzug",
      music_audio: "Musik & Audio",
      nature: "Natur",
      numbers: "Zahlen",
      photos_images: "Fotos & Bilder",
      political: "Politisch",
      punctuation_symbols: "Zeichensetzung & Symbole",
      religion: "Religion",
      science: "Wissenschaft",
      science_fiction: "Science-Fiction",
      security: "Sicherheit",
      shapes: "Formen",
      shopping: "Einkaufen",
      social: "Sozial",
      spinners: "Ladeanzeigen",
      sports_fitness: "Sport & Fitness",
      text_formatting: "Textformatierung",
      time: "Zeit",
      toggle: "Schalter",
      transportation: "Transport",
      travel_hotel: "Reise & Hotel",
      users_people: "Benutzer & Personen",
      weather: "Wetter",
      writing: "Schreiben",
    },
  },
  spanish: {
    ICON_LIST: {
      title: "Lista de Iconos",
      categories: "Categorías",
    },
    ICON_CATEGORIES: {
      accessibility: "Accesibilidad",
      alert: "Alerta",
      alphabet: "Alfabeto",
      animals: "Animales",
      arrows: "Flechas",
      astronomy: "Astronomía",
      automotive: "Automoción",
      buildings: "Edificios",
      business: "Negocios",
      camping: "Camping",
      charity: "Caridad",
      charts_diagrams: "Gráficos y Diagramas",
      childhood: "Infancia",
      clothing_fashion: "Ropa y Moda",
      coding: "Programación",
      communication: "Comunicación",
      connectivity: "Conectividad",
      construction: "Construcción",
      design: "Diseño",
      devices_hardware: "Dispositivos y Hardware",
      disaster: "Desastre",
      editing: "Edición",
      education: "Educación",
      emoji: "Emoji",
      energy: "Energía",
      files: "Archivos",
      film_video: "Cine y Video",
      food_beverage: "Comida y Bebida",
      fruits_vegetables: "Frutas y Verduras",
      gaming: "Juegos",
      gender: "Género",
      halloween: "Halloween",
      hands: "Manos",
      holidays: "Festividades",
      household: "Hogar",
      humanitarian: "Humanitario",
      logistics: "Logística",
      maps: "Mapas",
      maritime: "Marítimo",
      marketing: "Marketing",
      mathematics: "Matemáticas",
      media_playback: "Reproducción Multimedia",
      medical_health: "Salud y Medicina",
      money: "Dinero",
      moving: "Mudanza",
      music_audio: "Música y Audio",
      nature: "Naturaleza",
      numbers: "Números",
      photos_images: "Fotos e Imágenes",
      political: "Política",
      punctuation_symbols: "Puntuación y Símbolos",
      religion: "Religión",
      science: "Ciencia",
      science_fiction: "Ciencia Ficción",
      security: "Seguridad",
      shapes: "Formas",
      shopping: "Compras",
      social: "Social",
      spinners: "Indicadores de Carga",
      sports_fitness: "Deportes y Fitness",
      text_formatting: "Formato de Texto",
      time: "Tiempo",
      toggle: "Interruptores",
      transportation: "Transporte",
      travel_hotel: "Viajes y Hoteles",
      users_people: "Usuarios y Personas",
      weather: "Clima",
      writing: "Escritura",
    },
  },
  italian: {
    ICON_LIST: {
      title: "Elenco Icone",
      categories: "Categorie",
    },
    ICON_CATEGORIES: {
      accessibility: "Accessibilità",
      alert: "Allerta",
      alphabet: "Alfabeto",
      animals: "Animali",
      arrows: "Frecce",
      astronomy: "Astronomia",
      automotive: "Automotive",
      buildings: "Edifici",
      business: "Business",
      camping: "Campeggio",
      charity: "Beneficenza",
      charts_diagrams: "Grafici e Diagrammi",
      childhood: "Infanzia",
      clothing_fashion: "Abbigliamento e Moda",
      coding: "Programmazione",
      communication: "Comunicazione",
      connectivity: "Connettività",
      construction: "Costruzioni",
      design: "Design",
      devices_hardware: "Dispositivi e Hardware",
      disaster: "Disastro",
      editing: "Modifica",
      education: "Istruzione",
      emoji: "Emoji",
      energy: "Energia",
      files: "File",
      film_video: "Film e Video",
      food_beverage: "Cibo e Bevande",
      fruits_vegetables: "Frutta e Verdura",
      gaming: "Gaming",
      gender: "Genere",
      halloween: "Halloween",
      hands: "Mani",
      holidays: "Festività",
      household: "Ambiente domestico",
      humanitarian: "Umanitario",
      logistics: "Logistica",
      maps: "Mappe",
      maritime: "Marittimo",
      marketing: "Marketing",
      mathematics: "Matematica",
      media_playback: "Riproduzione Multimediale",
      medical_health: "Salute e Medicina",
      money: "Denaro",
      moving: "Trasloco",
      music_audio: "Musica e Audio",
      nature: "Natura",
      numbers: "Numeri",
      photos_images: "Foto e Immagini",
      political: "Politica",
      punctuation_symbols: "Punteggiatura e Simboli",
      religion: "Religione",
      science: "Scienza",
      science_fiction: "Fantascienza",
      security: "Sicurezza",
      shapes: "Forme",
      shopping: "Shopping",
      social: "Sociale",
      spinners: "Indicatori di Caricamento",
      sports_fitness: "Sport e Fitness",
      text_formatting: "Formattazione del Testo",
      time: "Tempo",
      toggle: "Interruttori",
      transportation: "Trasporti",
      travel_hotel: "Viaggi e Hotel",
      users_people: "Utenti e Persone",
      weather: "Meteo",
      writing: "Scrittura",
    },
  },
  ch: {
    ICON_LIST: {
      title: "图标列表",
      categories: "分类",
    },
    ICON_CATEGORIES: {
      accessibility: "无障碍",
      alert: "警报",
      alphabet: "字母表",
      animals: "动物",
      arrows: "箭头",
      astronomy: "天文学",
      automotive: "汽车",
      buildings: "建筑",
      business: "商务",
      camping: "露营",
      charity: "慈善",
      charts_diagrams: "图表与示意图",
      childhood: "童年",
      clothing_fashion: "服饰与时尚",
      coding: "编码",
      communication: "通信",
      connectivity: "连接",
      construction: "建筑施工",
      design: "设计",
      devices_hardware: "设备与硬件",
      disaster: "灾害",
      editing: "编辑",
      education: "教育",
      emoji: "表情符号",
      energy: "能源",
      files: "文件",
      film_video: "电影与视频",
      food_beverage: "餐饮",
      fruits_vegetables: "水果和蔬菜",
      gaming: "游戏",
      gender: "性别",
      halloween: "万圣节",
      hands: "手势",
      holidays: "节日",
      household: "家居",
      humanitarian: "人道",
      logistics: "物流",
      maps: "地图",
      maritime: "海事",
      marketing: "营销",
      mathematics: "数学",
      media_playback: "媒体播放",
      medical_health: "医疗与健康",
      money: "金钱",
      moving: "搬运",
      music_audio: "音乐与音频",
      nature: "自然",
      numbers: "数字",
      photos_images: "照片与图像",
      political: "政治",
      punctuation_symbols: "标点与符号",
      religion: "宗教",
      science: "科学",
      science_fiction: "科幻",
      security: "安全",
      shapes: "形状",
      shopping: "购物",
      social: "社交",
      spinners: "加载指示器",
      sports_fitness: "体育与健身",
      text_formatting: "文本格式",
      time: "时间",
      toggle: "切换",
      transportation: "交通运输",
      travel_hotel: "旅行与酒店",
      users_people: "用户与人物",
      weather: "天气",
      writing: "写作",
    },
  },
  japan: {
    ICON_LIST: {
      title: "アイコン一覧",
      categories: "カテゴリ",
    },
    ICON_CATEGORIES: {
      accessibility: "アクセシビリティ",
      alert: "警告",
      alphabet: "アルファベット",
      animals: "動物",
      arrows: "矢印",
      astronomy: "天文学",
      automotive: "自動車",
      buildings: "建物",
      business: "ビジネス",
      camping: "キャンプ",
      charity: "慈善",
      charts_diagrams: "チャートとダイアグラム",
      childhood: "子ども",
      clothing_fashion: "衣料・ファッション",
      coding: "コーディング",
      communication: "コミュニケーション",
      connectivity: "接続性",
      construction: "建設",
      design: "デザイン",
      devices_hardware: "デバイスとハードウェア",
      disaster: "災害",
      editing: "編集",
      education: "教育",
      emoji: "絵文字",
      energy: "エネルギー",
      files: "ファイル",
      film_video: "映画とビデオ",
      food_beverage: "飲食",
      fruits_vegetables: "果物と野菜",
      gaming: "ゲーム",
      gender: "ジェンダー",
      halloween: "ハロウィン",
      hands: "手",
      holidays: "祝日・ホリデー",
      household: "家庭",
      humanitarian: "人道支援",
      logistics: "物流",
      maps: "地図",
      maritime: "海事",
      marketing: "マーケティング",
      mathematics: "数学",
      media_playback: "メディア再生",
      medical_health: "医療・健康",
      money: "お金",
      moving: "引っ越し",
      music_audio: "音楽・オーディオ",
      nature: "自然",
      numbers: "数字",
      photos_images: "写真と画像",
      political: "政治",
      punctuation_symbols: "句読点と記号",
      religion: "宗教",
      science: "科学",
      science_fiction: "サイエンスフィクション",
      security: "セキュリティ",
      shapes: "図形",
      shopping: "ショッピング",
      social: "ソーシャル",
      spinners: "スピナー",
      sports_fitness: "スポーツ・フィットネス",
      text_formatting: "テキスト書式",
      time: "時間",
      toggle: "トグル",
      transportation: "輸送",
      travel_hotel: "旅行・ホテル",
      users_people: "ユーザーと人々",
      weather: "天気",
      writing: "ライティング",
    },
  },
  france: {
    ICON_LIST: {
      title: "Liste d'icônes",
      categories: "Catégories",
    },
    ICON_CATEGORIES: {
      accessibility: "Accessibilité",
      alert: "Alerte",
      alphabet: "Alphabet",
      animals: "Animaux",
      arrows: "Flèches",
      astronomy: "Astronomie",
      automotive: "Automobile",
      buildings: "Bâtiments",
      business: "Affaires",
      camping: "Camping",
      charity: "Charité",
      charts_diagrams: "Graphiques et Diagrammes",
      childhood: "Enfance",
      clothing_fashion: "Vêtements et Mode",
      coding: "Programmation",
      communication: "Communication",
      connectivity: "Connectivité",
      construction: "Construction",
      design: "Design",
      devices_hardware: "Appareils et Matériel",
      disaster: "Catastrophe",
      editing: "Édition",
      education: "Éducation",
      emoji: "Émojis",
      energy: "Énergie",
      files: "Fichiers",
      film_video: "Film et Vidéo",
      food_beverage: "Alimentation et Boissons",
      fruits_vegetables: "Fruits et Légumes",
      gaming: "Jeux vidéo",
      gender: "Genre",
      halloween: "Halloween",
      hands: "Mains",
      holidays: "Fêtes",
      household: "Maison",
      humanitarian: "Humanitaire",
      logistics: "Logistique",
      maps: "Cartes",
      maritime: "Maritime",
      marketing: "Marketing",
      mathematics: "Mathématiques",
      media_playback: "Lecture Multimédia",
      medical_health: "Santé et Médecine",
      money: "Argent",
      moving: "Déménagement",
      music_audio: "Musique et Audio",
      nature: "Nature",
      numbers: "Nombres",
      photos_images: "Photos et Images",
      political: "Politique",
      punctuation_symbols: "Ponctuation et Symboles",
      religion: "Religion",
      science: "Science",
      science_fiction: "Science-fiction",
      security: "Sécurité",
      shapes: "Formes",
      shopping: "Shopping",
      social: "Social",
      spinners: "Indicateurs de Chargement",
      sports_fitness: "Sports et Fitness",
      text_formatting: "Mise en forme du texte",
      time: "Temps",
      toggle: "Bascule",
      transportation: "Transport",
      travel_hotel: "Voyage et Hôtel",
      users_people: "Utilisateurs et Personnes",
      weather: "Météo",
      writing: "Écriture",
    },
  },
};
